<template>
  <transition v-if="isDisplay()" name="fade">
    <div class="fixed-button">
      <a @click="openSearchFilter" href="javascript:void(0)">
        {{ name }}
      </a>
    </div>
  </transition>
</template>

<script>
import { config } from '@/utils/config'
export default {
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dataScrollY: {
        type: Number,
        default: 0
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  /* istanbul ignore next */
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      // スクロール位置をセット
      this.dataScrollY = window.pageYOffset
    },
    isDisplay() {
      return this.dataScrollY > config.fixedSearchFooterPageYOffset
    },
    openSearchFilter() {
      this.$store.dispatch('search_condition/openSearchFilter', true)
    }
  }
}
</script>
